import {
  CREATING_USER_GROUP_REQUEST, CREATING_USER_GROUP_SUCCEDDED, CREATING_USER_GROUP_FAILED,
  UPDATING_USER_GROUP_REQUEST, UPDATING_USER_GROUP_SUCCEDDED, UPDATING_USER_GROUP_FAILED,
  FETCHING_USER_GROUPS_REQUEST, FETCHING_USER_GROUPS_SUCCEDDED, FETCHING_USER_GROUPS_FAILED,
  FETCHING_USER_GROUP_REQUEST, FETCHING_USER_GROUP_SUCCEDDED, FETCHING_USER_GROUP_FAILED,
  DELETING_USER_GROUP_REQUEST, DELETING_USER_GROUP_SUCCEDDED, DELETING_USER_GROUP_FAILED,
  ADD_USER_TO_USER_GROUP, REMOVE_USER_FROM_USER_GROUP
} from 'src/legacy/redux/actions/actionTypes.jsx';
import _ from 'lodash';

const initialState = {
  loading: false,
  invalidated: true,
  creating: false,
  error: null,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1
  },
  userGroup: {

  }
};

const userGroupState = {
  id: 0,
  updating: false,
  deleting: false,
  loading: false,
  item: null
}

function userGroupReducer(state = initialState, action) {
  switch (action.type) {
    case CREATING_USER_GROUP_REQUEST:
      return Object.assign({}, state, {
        ...state,
        creating: true
      });

    case CREATING_USER_GROUP_SUCCEDDED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      var users = action.payload.users || [];
      users = users.map(item => {
        return {
          ...item,
          persisted: true
        }
      });

      var items = state.items.slice();
      items.splice(state.items.length, 0, action.payload);

      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return Object.assign({}, state, {
        ...state,
        creating: false,
        items: items,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            creating: false,
            item: {
              ...action.payload,
              users: users
            }
          }
        }
      });

    case CREATING_USER_GROUP_FAILED:
      return Object.assign({}, state, {
        ...state,
        creating: false,
        error: action.payload
      });

    case UPDATING_USER_GROUP_REQUEST:
      var id = action.payload;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            updating: true
          }
        }
      });

    case UPDATING_USER_GROUP_SUCCEDDED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      var users = action.payload.userGroup.users || [];
      users = users.map(item => {
        return {
          ...item,
          persisted: true
        }
      });

      var items = state.items.map((item, index) => {
        if (item.id != id) {
          return item;
        }

        return {
          ...action.payload.userGroup
        };
      })
      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return Object.assign({}, state, {
        ...state,
        items: items,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            updating: false,
            item: {
              ...action.payload.userGroup,
              users: users
            }
          }
        }
      });

    case UPDATING_USER_GROUP_FAILED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            updating: false,
            error: action.payload.error
          }
        }
      });

    case FETCHING_USER_GROUPS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true
      })

    case FETCHING_USER_GROUPS_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage != 0) {
        items = [...state.items, ...action.payload.records];
      } else {
        items = action.payload.records
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages
        }
      })

    case FETCHING_USER_GROUPS_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      })

    case FETCHING_USER_GROUP_REQUEST:
      var id = action.payload;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            loading: true
          }
        }
      });

    case FETCHING_USER_GROUP_SUCCEDDED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      var users = action.payload.userGroup.users || [];
      users = users.map(item => {
        return {
          ...item,
          persisted: true
        }
      })

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            loading: false,
            item: {
              ...action.payload.userGroup,
              users: users
            }
          }
        }
      });

    case FETCHING_USER_GROUP_FAILED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            loading: false,
            error: action.payload.error
          }
        }
      });

    case DELETING_USER_GROUP_REQUEST:
      var id = action.payload;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            deleting: true
          }
        }
      })

    case DELETING_USER_GROUP_SUCCEDDED:
      var id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            item: null,
            deleting: false
          }
        },
        items: state.items.filter((userGroup, index) => {
          return userGroup.id != id;
        })
      })

    case DELETING_USER_GROUP_FAILED:
      var id = action.payload.id;
      var userGroup = state.userGroup[id] || userGroupState;

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            deleting: false
          }
        },
      })

    case ADD_USER_TO_USER_GROUP:
      var id = action.payload.id;
      var user = action.payload.user;

      var userGroup = state.userGroup[id] || userGroupState;

      var index = userGroup.item.users.findIndex(item => {
        return item.id === user.id;
      })

      if (index == -1) {
        return Object.assign({}, state, {
          ...state,
          userGroup: {
            ...state.userGroup,
            [id]: {
              ...userGroup,
              item: {
                ...userGroup.item,
                users: [
                  ...userGroup.item.users,
                  user
                ]
              }
            }
          }
        });
      } else {
        return state;
      }

    case REMOVE_USER_FROM_USER_GROUP:
      var id = action.payload.id;
      var user = action.payload.user;

      var userGroup = state.userGroup[id] || userGroupState;

      var users = userGroup.item.users.filter(item => {
        return item.id != user.id;
      })

      return Object.assign({}, state, {
        ...state,
        userGroup: {
          ...state.userGroup,
          [id]: {
            ...userGroup,
            item: {
              ...userGroup.item,
              users: users
            }
          }
        }
      });

    default:
      return state
  }
}

export { userGroupReducer };